export const mlServiceLocationsMockData = {
  studios: {
    Indiana: [
      {
        Id: 47,
        objectID: '123',
        Name: 'Indianapolis South',
        City: 'Indianapolis',
        Address: '5221 Noggle Way',
        State: 'Indiana',
        Zip: '46237',
        pageUrl: '/where-we-build/indianapolis-south',
        CsAddress: '1155 Pike Place',
        CsName: 'Indianapolis',
        CsPhoneNumber: '(123) 456 5555',
        directionsLink:
          'https://www.google.com/maps/place/5087+Columbus+Pike...',
        hours: [
          {
            dates: {
              days: 'Mon, Wed, Fri',
              hours: '9am–6pm',
              _metadata: { uid: 'mock-uid-1' },
            },
          },
          {
            dates: {
              days: 'Tue, Thu',
              hours: '10am–8pm',
              _metadata: { uid: 'mock-uid-2' },
            },
          },
          {
            dates: {
              days: 'Sat',
              hours: '9am–5pm',
              _metadata: { uid: 'mock-uid-3' },
            },
          },
        ],
      },
    ],
    Kentucky: [
      {
        Id: 44,
        objectID: '123',
        Name: 'Louisville',
        City: 'Louisville',
        Address: '121 Huntington Ridge Drive',
        State: 'Kentucky',
        Zip: '40223',
        pageUrl: '',
        CsAddress: '',
        CsName: '',
        CsPhoneNumber: '(123) 456 5555',
        directionsLink: '',
        hours: [
          {
            dates: {
              days: 'Mon, Wed, Fri',
              hours: '9am–6pm',
              _metadata: { uid: 'mock-uid-1' },
            },
          },
          {
            dates: {
              days: 'Tue, Thu',
              hours: '10am–8pm',
              _metadata: { uid: 'mock-uid-2' },
            },
          },
          {
            dates: {
              days: 'Sat',
              hours: '9am–5pm',
              _metadata: { uid: 'mock-uid-3' },
            },
          },
        ],
      },
    ],
    Louisiana: [
      {
        Id: 21,
        objectID: '123',
        Name: 'Lafayette',
        City: 'Scott',
        Address: '812 S Frontage Rd',
        State: 'Louisiana',
        Zip: '70583',
        pageUrl: '',
        CsAddress: '',
        CsName: '',
        CsPhoneNumber: '(123) 456 5555',
        directionsLink: '',
        hours: [
          {
            dates: {
              days: 'Mon, Wed, Fri',
              hours: '9am–6pm',
              _metadata: { uid: 'mock-uid-1' },
            },
          },
          {
            dates: {
              days: 'Tue, Thu',
              hours: '10am–8pm',
              _metadata: { uid: 'mock-uid-2' },
            },
          },
          {
            dates: {
              days: 'Sat',
              hours: '9am–5pm',
              _metadata: { uid: 'mock-uid-3' },
            },
          },
        ],
      },
      {
        Id: 20,
        objectID: '123',
        Name: 'Baton Rouge/New Orleans',
        City: 'Holden',
        Address: '27735 James Chapel Rd.',
        State: 'Louisiana',
        Zip: '70744',
        pageUrl: '',
        CsAddress: '',
        CsName: '',
        CsPhoneNumber: '(123) 456 5555',
        directionsLink: '',
        hours: [
          {
            dates: {
              days: 'Mon, Wed, Fri',
              hours: '9am–6pm',
              _metadata: { uid: 'mock-uid-1' },
            },
          },
          {
            dates: {
              days: 'Tue, Thu',
              hours: '10am–8pm',
              _metadata: { uid: 'mock-uid-2' },
            },
          },
          {
            dates: {
              days: 'Sat',
              hours: '9am–5pm',
              _metadata: { uid: 'mock-uid-3' },
            },
          },
        ],
      },
    ],
  },
  otherDepartments: [
    {
      department_name: 'Careers',
      department_phone_number: '(123) 456 5555',
      _metadata: { uid: 'cs00c92af40aba62fc' },
    },
    {
      department_name: 'Media Relations',
      department_phone_number: '(123) 456 5555',
      _metadata: { uid: 'cs0fbf4aad2f6535f2' },
    },
    {
      department_name: 'Partnerships',
      department_phone_number: '(123) 456 5555',
      _metadata: { uid: 'cs03ea5e69f7831a9b' },
    },
  ],
};
